import { Phone, Mail, MapPin } from "lucide-react";
import { SITE } from "@/lib/site";
import { OPEN_SETTINGS_EVENT } from "@/lib/clarity";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#0B132B]/80 backdrop-blur-md text-white border-t-2 border-[#D92525]">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={SITE.logo}
                alt="Swedcro logo"
                className="h-12 w-auto object-contain bg-white p-1"
              />
              <div className="font-display font-black text-2xl tracking-tight">
                SWED<span className="text-[#D92525]">CRO</span>
              </div>
            </div>
            <p className="font-body text-white/70 mt-4 max-w-md text-sm leading-relaxed">
              Måleri, fasad, renovering och tapetsering i Eskilstuna och
              hela närområdet. Vi kommer hem till dig.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-display font-bold text-xs uppercase tracking-[0.18em] text-[#D92525]">
              Kontakt
            </div>
            <ul className="mt-4 space-y-3 font-body text-sm text-white/85">
              <li className="flex items-center gap-2">
                <Phone size={14} className="text-[#D92525]" />
                <a href={SITE.phoneHref} className="hover:text-[#D92525]">
                  {SITE.phone}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={14} className="text-[#D92525]" />
                <a href={`mailto:${SITE.email}`} className="hover:text-[#D92525]">
                  {SITE.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin size={14} className="text-[#D92525]" />
                Eskilstuna, Sverige
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-display font-bold text-xs uppercase tracking-[0.18em] text-[#D92525]">
              Tjänster
            </div>
            <ul className="mt-4 grid grid-cols-2 gap-y-2 font-body text-sm text-white/85">
              <li>Måleri</li>
              <li>Fasad</li>
              <li>Renovering</li>
              <li>Tapetsering</li>
              <li>Mosaik / Sockelputs</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/15 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="font-body text-xs text-white/60">
            © {year} Swedcro Måleri & Fasad. Alla rättigheter förbehållna.
          </p>
          <p className="font-body text-xs text-white/60">
            Eskilstuna · F-skatt · Försäkrade ·{" "}
            <a href="/integritetspolicy" data-testid="footer-privacy-link" className="hover:text-white/90 underline-offset-2 hover:underline">
              Integritetspolicy
            </a>{" "}
            ·{" "}
            <button
              type="button"
              data-testid="footer-cookie-settings"
              onClick={() => window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT))}
              className="hover:text-white/90 underline-offset-2 hover:underline"
            >
              Cookie-inställningar
            </button>{" "}
            ·{" "}
            <a href="/admin/login" data-testid="footer-admin-link" className="hover:text-white/90 underline-offset-2 hover:underline">
              Admin
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
